import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

export default function Newsletter() {
  useEffect(() => {
    if (window.ml) {
      window.ml("account", "1545109");
    }

    // Override MailerLite button styles after form loads
    const styleButton = () => {
      const buttons = document.querySelectorAll('.ml-form-embedWrapper button, .embeddedForm button');
      buttons.forEach(btn => {
        btn.style.setProperty('background-color', '#457B9D', 'important');
        btn.style.setProperty('background', '#457B9D', 'important');
        btn.style.setProperty('border-radius', '0.5rem', 'important');
      });
    };

    // Run immediately and also watch for DOM changes
    const observer = new MutationObserver(styleButton);
    observer.observe(document.body, { childList: true, subtree: true });

    // Also run on interval briefly to catch late-loading elements
    const interval = setInterval(styleButton, 100);
    setTimeout(() => clearInterval(interval), 3000);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);
  return (
    <div className="h-screen">
      <Helmet>
        <title>Newsletter | Pathway Resource Center</title>
        <meta
          name="description"
          content="Get signed up for newsletter emails and important updates about Pathway Resource Center."
        />
      </Helmet>
      <div className="mx-auto h-1/2 pt-24 md:w-1/2">
        <div className="ml-embedded embeddedForm" data-form="niG4PN"></div>
      </div>
    </div>
  );
}
